import 'core-js/es/array/flat';
import 'core-js/es/array/flat-map';
import 'core-js/es/object/from-entries';
import 'core-js/es/string/match-all';
import 'core-js/es/global-this';
import 'core-js/web/queue-microtask';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
// Import API config to set global API_URL
import './config/apiConfig';

const isLikelyTvBrowser = () => {
    const ua = navigator.userAgent || '';
    return /Android\s.*TV|SMART-TV|SmartTV|BRAVIA|AFT[A-Z0-9]|HbbTV|CrKey|TV Safari|GoogleTV|AppleTV|WebOS|Web0S|Tizen/i.test(ua);
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <AuthProvider>
            <App />
        </AuthProvider>
    </BrowserRouter>
);

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        // Android TV browsers often keep a stale index.html via the service worker
        // after a hashed CRA deploy, which shows up as a permanent white screen.
        if (isLikelyTvBrowser()) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                registrations.forEach((registration) => registration.unregister());
            }).catch(() => null);
            return;
        }

        navigator.serviceWorker.register("/sw.js").catch((error) => {
            console.error("Service worker registration failed:", error);
        });
    });
}
